import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0eafeccf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"100vh"} }, null, -1))
const _hoisted_2 = {
  key: 1,
  class: "app-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: _ctx.locale }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_a_spin, {
            key: 0,
            size: "large",
            tip: "正在加载数据中...",
            delay: 500
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_router_view)
          ]))
    ]),
    _: 1
  }, 8, ["locale"]))
}